/*
 * Authors: mariushirjanu
 * Created: 11/04/2017
 * Upgraded: 31/01/2023
 */
import * as _ from 'underscore';
import { util } from '../util';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IBreadcrumb } from './breadcrumb.service';
import { trackByFunction } from '../formly/ga-formly.util';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'breadcrumb',
  template: `
    <li [ngClass]="{active: current}">
      <span class="plain-text" *ngIf="current">{{breadcrumb.title}}</span>
      <a *ngIf="!current" [uiSref]="breadcrumb.state" [uiParams]="breadcrumb.stateParams" [uiOptions]="{inherit: true}">{{breadcrumb.title}}</a>
    </li>
  `
})
export class BreadcrumbComponent implements OnChanges {
  @Input() public breadcrumb:IBreadcrumb;
  public trackByFunction:Function = trackByFunction;
  public current:boolean;

  constructor(
    private stateService:StateService
  ) {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.breadcrumb) {
      this.breadcrumb = changes.breadcrumb.currentValue;
      this.setCurrentBreadcrumbState();
    }
  }

  public setCurrentBreadcrumbState():void {
    // make sure that current state parameters are set in the breadcrumb params
    let matchAllStateParameters:boolean = true;
    _.each(this.stateService.params, (value:any, key:string) => {
      if(util.notNullOrUndefined(value) && !_.isFunction(value) && key !== 'frameless' && !_.has(this.breadcrumb.stateParams, key)){
        matchAllStateParameters = false;
        return;
      }
    });

    this.current = this.stateService.is(this.breadcrumb.state, this.breadcrumb.stateParams) && matchAllStateParameters;
  }
}